import { render, staticRenderFns } from "./addpack.vue?vue&type=template&id=20f1e0f8&scoped=true&"
import script from "./addpack.vue?vue&type=script&lang=js&"
export * from "./addpack.vue?vue&type=script&lang=js&"
import style0 from "./addpack.vue?vue&type=style&index=0&id=20f1e0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1e0f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f1e0f8')) {
      api.createRecord('20f1e0f8', component.options)
    } else {
      api.reload('20f1e0f8', component.options)
    }
    module.hot.accept("./addpack.vue?vue&type=template&id=20f1e0f8&scoped=true&", function () {
      api.rerender('20f1e0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addpack.vue"
export default component.exports